<div class="flex flex-col @container">
  <div class="flex flex-col @md:flex-row @md:items-center gap-5 py-5 px-4 w-full overflow-hidden">
    <div class="flex-1 flex gap-2 items-center">
      <div class="flex-none">
        <ng-content select="[slot=icon]" />
      </div>
      <div>
        <div class="text-xl font-semibold leading-7">
          <ng-content select="[slot=title]" />
        </div>
        <ng-content select="[slot=error]" />
      </div>
    </div>
    <div class="flex-none">
      <ui-switch-bar
        [formField]="form.result"
        class="w-full @md:w-[120px] inline-block"
        (fieldValueChange)="onSwitchChange($any($event))"
      >
        <ui-switch-bar-option
          value="NONE"
          [uiTooltip]="'cockpit.supplierContracts.check.form.resultNone' | transloco"
        >
          <ng-icon name="heroMinus" size="20" class="!block" />
        </ui-switch-bar-option>
        <ui-switch-bar-option
          value="INFO"
          mode="primary"
          [uiTooltip]="'cockpit.supplierContracts.check.form.resultInfo' | transloco"
        >
          <ng-icon name="roundedSquare" size="11" class="!block" />
        </ui-switch-bar-option>
        <ui-switch-bar-option
          value="ALERT"
          mode="destructive"
          [uiTooltip]="'cockpit.supplierContracts.check.form.resultAlert' | transloco"
        >
          <ng-icon name="heroXMark" size="20" class="!block" />
        </ui-switch-bar-option>
      </ui-switch-bar>
    </div>
  </div>
  <div
    class="overflow-hidden transition-[height] duration-300"
    uiDetectBrowser
    [ngClass]="form.result().value() === 'NOT_SET' ? 'closed' : 'open'"
  >
    <div class="pt-4 px-6 pb-16 flex flex-col gap-6">
      <ui-input-label>
        <div class="flex">
          <span class="flex-1">
            {{ 'cockpit.supplierContracts.check.form.explanationLabel' | transloco }}
            @if (form.result().value() === 'ALERT' || form.result().value() === 'INFO') {
              <span class="text-error dark:text-error-darkmode">*</span>
            }
          </span>
          @if (!(form.result().value() === 'ALERT' || form.result().value() === 'INFO')) {
            <span
              class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm font-normal"
            >
              {{ 'validators.optional' | transloco }}
            </span>
          }
        </div>
        <ui-textarea
          [formField]="form.explanation"
          [debounceMs]="500"
          (fieldValueChange)="onExplanationChange($event)"
          rows="2"
        />
        <app-field-errors slot="bottom" [fieldState]="form.explanation()" />
      </ui-input-label>
      <ui-input-label labelFor="">
        <div class="flex">
          <span class="flex-1">{{
            'cockpit.supplierContracts.check.form.reportLabel' | transloco
          }}</span>
          <span
            class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm font-normal"
          >
            {{ 'validators.optional' | transloco }}
          </span>
        </div>
        <ui-dropzone slot="input" (dropFiles)="onFileDrop($event)" accept="application/pdf">
          <ng-container slot="title">
            {{ 'cockpit.supplierContracts.check.form.dropzoneTitlePrefix' | transloco }}
            <label
              class="text-primary dark:text-primary-darkmode hover:underline cursor-pointer"
              for="upload-documents-input"
            >
              {{ 'cockpit.supplierContracts.check.form.dropzoneTitleLink' | transloco }}
            </label>
            {{ 'cockpit.supplierContracts.check.form.dropzoneTitleSuffix' | transloco }}
            <input
              type="file"
              class="hidden"
              id="upload-documents-input"
              (change)="onFileChange($event)"
              accept="application/pdf"
            />
          </ng-container>
          <ng-container slot="dragover-title">
            {{ 'cockpit.supplierContracts.check.form.dropzoneDragoverTitle' | transloco }}
          </ng-container>
          <ng-container slot="subtitle">
            {{ 'cockpit.supplierContracts.check.form.dropzoneSubtitle' | transloco }}
          </ng-container>
          @let state = fileUpload();
          @if (state.file !== null) {
            <ui-dropzone-file
              [error]="state.uploadError"
              [titleText]="'cockpit.supplierContracts.check.form.reportTitle' | transloco"
              [subtitle]="
                'cockpit.supplierContracts.check.form.uploadProgress'
                  | transloco: { progress: state.progress }
              "
              [progress]="state.progress"
              [transitionDuration]="300"
            />
          }
        </ui-dropzone>
      </ui-input-label>
    </div>
  </div>
</div>
